import { useQuery } from '@tanstack/react-query';
import apiClient from '../../../hooks/apiClient';

const lastInvoiceKeys = {
  all: ['afip', 'last-invoice'],
  detail: (salePointNumber, voucherType) => [
    ...lastInvoiceKeys.all,
    salePointNumber,
    voucherType,
  ],
};

const fetchLastInvoice = async ({ salePointNumber, voucherType }) => {
  const params = new URLSearchParams({
    sale_point: salePointNumber,
    voucher_type: voucherType,
  });

  const response = await apiClient.get(`afip/latest-invoice?${params.toString()}`);
  return response.data;
};

export const useLastInvoice = ({ salePointNumber, voucherType }, options = {}) => {
  return useQuery({
    queryKey: lastInvoiceKeys.detail(salePointNumber, voucherType),
    queryFn: () => fetchLastInvoice({ salePointNumber, voucherType }),
    enabled: Boolean(salePointNumber && voucherType) && (options.enabled ?? true),
    retry: 1,
    ...options,
  });
};

export const lastInvoiceQueryKeys = lastInvoiceKeys;
